

import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { toast } from "react-toastify";
import React, { useEffect } from "react";
import { requestForToken, onMessageListener } from "./firebase";
import AboutUs from "./components/About";
import Applicant from "./components/Brand/Applicant.jsx";
import BrandArrivalRequest from "./components/Brand/BrandArrivalRequest";
import BrandConsignments from "./components/Brand/BrandConsignments";
import BrandHistory from "./components/Brand/BrandHistory";
import PartnerBrands from "./components/Influencer/PartnerBrands.jsx";
import BrandHome from "./components/Brand/BrandHome";
import BrandInfluencerGetDetail from "./components/Brand/Brandinfluncergetdetails.jsx";
import BrandIntro from "./components/Brand/BrandIntro";
import BrandLogin from "./components/Brand/BrandLogin";
import BrandPendingRequest from "./components/Brand/BrandPendingRequest";
import BrandProfile from "./components/Brand/BrandProfile.jsx";
import BrandProfileEdit from "./components/Brand/BrandProfileEdit.jsx";
import BrandSignUp from "./components/Brand/BrandSignUp";
import InfluencerCompare from "./components/Brand/InfluencerCompare";
import Influencerconsolidation from './components/Brand/Influencerconsolidation';
import InfluencerDetails from "./components/Brand/InfluencerDetails";
import BrandDetails from "./components/Influencer/BrandDetails";
import InfluencerArrivalRequest from "./components/Influencer/InfluencerArrivalRequest";
import InfluencerConsignments from "./components/Influencer/InfluencerConsignments";
import InfluencerHistory from "./components/Influencer/InfluencerHistory";
import InfluencerHome from "./components/Influencer/InfluencerHome";
import InfluencerIntro from "./components/Influencer/InfluencerIntro";
import InfluencerLogin from "./components/Influencer/InfluencerLogin";
import InfluencerPendingRequest from "./components/Influencer/InfluencerPendingRequest";
import InfluencerProfile from "./components/Influencer/InfluencerProfile";
import InfluencerProfileEdit from "./components/Influencer/InfluencerProfileEdit";
import InfluencerSignUp from "./components/Influencer/InfluencerSignUp";
import AddNewBrand from './components/manager/AddNewBrand';
import AddNewInfluencer from './components/manager/AddNewInfluencer';
import AllInfluencerDetails from "./components/manager/Allinfluencerdetails.jsx";
import EditInfluencer from "./components/manager/Editinfluencer.jsx";
import ManagerHeader from './components/manager/ManagerHeader';
import ManagerHome from './components/manager/ManagerHome';
import ManagerLogin from './components/manager/ManagerLogin';
import ManagerProfile from './components/manager/ManagerProfile';
import ManagerSignUp from "./components/manager/ManagerSignUp";
import NewToSite from "./components/Newtosite";
import Home from "./Home";

// Import the CreateCampaign component
import BrandEnterEmail from "./components/Brand/Brandenteremail.jsx";
import ChangePasswordBrand from "./components/Brand/ChangepasswordBrand.jsx";
import CreateCampaign from "./components/Brand/CreateCampaign";
import MyRequest from "./components/Brand/myrequest.jsx";
import Otpenterbrand from './components/Brand/Otpenterbrand';
import ChangePasswordInfluencer from "./components/Influencer/ChangePasswordInfluencer.jsx";
import InfluencerEmail from "./components/Influencer/InfluencerEmail.jsx";
import OtpEnterInfluencer from "./components/Influencer/OtpEnterInfluence.jsx";
import CsvUploader from "./components/manager/CsvUploader.jsx";
import PendingRequest from "./components/manager/pendingrequest.jsx";
import UpdateProfile from "./components/manager/updateprofile.jsx";
import SubmittedComplaint from "./components/Brand/submittedcomplaint.jsx";
import Addinfluenecerplan from "./components/Brand/Addinfluenecrslist.jsx";
import AllInfluencerDetails2 from "./components/Brand/AllInfluencerDetails2.jsx";
import ApplicantPostsMetrics from "./components/Brand/ApplicantsmetricsPost.jsx";
import CampaignReports from "./components/Brand/campaignreports.jsx";
import InfluencerDetails3 from "./components/Brand/influencerdetailbrand.jsx";
import MessageBox from "./components/Brand/Messagebrand.jsx";
import MultipleInvitesModal from "./components/Brand/multipleinviteinfluencers.jsx";
import MyCampaigns from "./components/Brand/Mycampaigns.jsx";
import MyPlan from "./components/Brand/planAndlist.jsx";
import RaiseComplaint from "./components/Brand/RaiseComplaint.jsx";
import Reels from "./components/Brand/Reels";
import SearchDetailsPage from "./components/Brand/searchdetails.jsx";
import SearchPage from "./components/Brand/searhpage1.jsx";
import ComingSoon from "./components/Influencer/commingsoon.jsx";
import ViewPlan from "./components/Brand/Veiwplan.jsx";
import ViewReport from "./components/Brand/Veiwreports.jsx";
import ApplyToCampaign from "./components/Influencer/applycampagin.jsx";
import BrandProfileinfo from "./components/Influencer/Brandprofileinfo.jsx";
import CampaignDetailsPage from "./components/Influencer/campaigndetailspage.jsx";
import LinkAccounts from "./components/Influencer/Linkaccount.jsx";
import MessageComponent from "./components/Influencer/Messages.jsx";
import MyCampaignsapplications from "./components/Influencer/Mycampaignsapplications.jsx";
import NotificationInfluencer from "./components/Influencer/NotificationInfluencer.jsx";
import RaiseComplaintInfluencers from "./components/Influencer/RaiseComplaintInfluencers.jsx";
import Addinfluenecerplan1 from "./components/manager/Addinfluencersplan.jsx";
import BrandCampaigns from "./components/manager/Brandcampaign.jsx";
import BrandComplaint from "./components/manager/Brandcomplaint.jsx";
import BulkUpload from "./components/manager/BulkUpload.jsx";
import ChangePasswordManage from "./components/manager/Changepasswordmanager.jsx";
import GetAllApplicants from "./components/manager/Getallappicants.jsx";
import InfluencersComplaint from "./components/manager/InfluencersComplaint.jsx";
import ManageEnterEmail from "./components/manager/Managerenteremail.jsx";
import Notifications from "./components/manager/Notifications.jsx";
import OtpEnterManage from "./components/manager/otpentermanage.jsx";
import MyPlan2 from "./components/manager/Planandlist.jsx";
import ReceiveCampaignDetails from "./components/manager/ReceiveCampaignDetails.jsx";
import SearchDetails1 from "./components/manager/searchdetails2.jsx";
import TableComponent from "./components/manager/searchpage2.jsx";
import SendPostRequest from "./components/manager/sendpostrequest.jsx";
import ViewPlan1 from "./components/manager/veiwplan1.jsx";
import InfluencerCostChecker from "./Tools/InfluencerCostChecker.jsx";
import InfluencerSubmittedComplaints from "./components/Influencer/influencersubmitted.jsx";
import CreateLink from "./components/Influencer/CreateLink.jsx";
import InstagramProductSelect from "./components/Influencer/instramproductselect.jsx";
import MyProducts from "./components/Influencer/MyProductspost.jsx";
import Productspost from "./components/Influencer/post.jsx";
import Shop from "./components/Influencer/shop.jsx";
import GenerateProductLink from "./components/Influencer/generateproductlink.jsx";
import AffiliateAnalytics from "./components/Influencer/AffiliateAnalytics.jsx";
import AmazonProductSearch from "./components/Influencer/Amazonproductsearch.jsx";
import WalmartSearch from "./components/Influencer/walmartsearch.jsx";
import AffiliateCsvUpload from "./components/manager/Affilatecsvupload.jsx";
import AffiliateRequests from "./components/manager/AffiliateRequests.jsx";
import InfluencerAffiliateEarnings from "./components/manager/InfluencerAffiliateEarnings.jsx";
const App = () => {
  
   useEffect(() => {
  onMessageListener()
    .then((payload) => {
      console.log("🔔 New Foreground Notification:", payload);

      const title = payload?.notification?.title || "Notification";
      const body = payload?.notification?.body || "";

      toast.info(
        <>
          <strong>{title}</strong>
          <br />
          {body}
        </>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
    })
    .catch((err) => {
      console.error("Foreground notification error: ", err);
    });
}, []);

  return (
    <BrowserRouter>
      <Routes>
      <Route path="/veiwreports" element={<ViewReport/>} />
      <Route path="/veiwplans" element={<ViewPlan/>} />
      <Route path="/veiwplans1" element={<ViewPlan1/>} />
      <Route path="/campaignreports" element={< CampaignReports/>} />
      <Route path="/planlist" element={<Addinfluenecerplan/>} />
      <Route path="/planlist1" element={< Addinfluenecerplan1/>} />
      <Route path="/tool" element={<Reels />} />
      <Route path="/searchdetails1" element={<SearchDetails1/>} />
      <Route path="/plan1" element={<MyPlan2 />} />
      <Route path="/plan" element={<MyPlan />} />
        <Route path="/" element={<Home />} />
        <Route path="/postmetrics" element={<ApplicantPostsMetrics />} />
        <Route path="/linkaccounts" element={<LinkAccounts />} />
        <Route path="/search" element={<SearchPage/>} />
        <Route path="/search1" element={<TableComponent/>} />
        <Route path="/upload" element={<BulkUpload/>} />
        <Route path="/searchdetails" element={<SearchDetailsPage />} />
        <Route path="/brandinfo" element={<BrandProfileinfo/>} />
        <Route path="/multinvite" element={<MultipleInvitesModal/>} />
        <Route path="/getappicants" element={<GetAllApplicants/>} />
        <Route path="/recivedetails2" element={<ReceiveCampaignDetails/>} />
        <Route path="/brandcampaigns" element={<BrandCampaigns/>} />
        <Route path="/costchecker" element={<InfluencerCostChecker/>} />
        <Route path="/messagebrand" element={<MessageBox/>} />
        <Route path="/infldetails" element={<InfluencerDetails3/>} />
        <Route path="/influenecermessage" element={<MessageComponent/>} />
        <Route path="/notifyinflueencers" element={<NotificationInfluencer/>} />
        <Route path="/requestpage" element={<SendPostRequest/>} />
        <Route path="/myapplications" element={<MyCampaignsapplications/>} />
        <Route path="/MyCampaigns" element={<MyCampaigns/>} />
     
        <Route path="/apply" element={<ApplyToCampaign />} />
        <Route path="/campaigndetails" element={<CampaignDetailsPage />} />

        <Route path="/notify" element={<Notifications />} />
        <Route path="/allinfluencer1" element={<AllInfluencerDetails />} />
        <Route path="/allinfluencer2" element={<AllInfluencerDetails2 />} />


        <Route path="/manageemail" element={<ManageEnterEmail/>} />
        <Route path="/changepassmanage" element={<ChangePasswordManage/>} />
        <Route path="/otpmanage" element={<OtpEnterManage/>} />


        <Route path="/brandemail" element={<BrandEnterEmail/>} />
        <Route path="/changepassbrand" element={<ChangePasswordBrand/>} />
        <Route path="/otpbrand" element={<Otpenterbrand/>} />


        {/* <Route path="/brandemail" element={<BrandEnterEmail/>} />
        <Route path="/changepassbrand" element={<ChangePasswordBrand/>} />
        <Route path="/otpbrand" element={<OtpEnterBrand/>} /> */}



        <Route path="/influenceremail" element={<InfluencerEmail/>} />
        <Route path="/changepassinfluencer" element={<ChangePasswordInfluencer/>} />
        <Route path="/influencerotp" element={<OtpEnterInfluencer/>} />
        <Route path="/updateagency" element={<UpdateProfile />} />
        <Route path="/request" element={<PendingRequest />} />
        <Route path="/myrequest" element={<MyRequest />} />
        <Route path="/applicant/:campaignId" element={<Applicant/>} />

        {/* <Route path="/applicant" element={< Applicant/>} /> */}
        <Route path="/upload" element={<CsvUploader/>} />
        <Route path="/edit" element={<EditInfluencer/>} />
        <Route path="/getdetails" element={<BrandInfluencerGetDetail/>} />
        <Route path="/BrandIntro" element={<BrandIntro />} />
        <Route path="/InfluencerIntro" element={<InfluencerIntro />} />
        <Route path="/BrandSignUp" element={<BrandSignUp />} />
        <Route path="/InfluencerSignUp" element={<InfluencerSignUp />} />
        <Route path="/ManagerSignUp" element={<ManagerSignUp />} />
        <Route path="/BrandLogin" element={<BrandLogin />} />
        <Route path="/InfluencerLogin" element={<InfluencerLogin />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/NewToSite" element={<NewToSite />} />
        <Route path="/BrandHome" element={<BrandHome />} />
        <Route path="/BrandPendingRequest" element={<BrandPendingRequest />} />
        <Route path="/BrandArrivalRequest" element={<BrandArrivalRequest />} />
        <Route path="/BrandConsignments" element={<BrandConsignments />} />
        <Route path="/BrandDetails" element={<BrandDetails />} />
        <Route path="/BrandProfile" element={<BrandProfile />} />
        <Route path="/BrandProfileEdit" element={<BrandProfileEdit />} />
        <Route path="/BrandHistory" element={<BrandHistory />} />
        <Route path="/InfluencerDetails" element={<InfluencerDetails />} />
        <Route path="/InfluencerHome" element={<InfluencerHome />} />
        <Route path="/InfluencerArrivalRequest" element={<InfluencerArrivalRequest />} />
        <Route path="/InfluencerProfile" element={<InfluencerProfile />} />
        <Route path="/InfluencerProfileEdit" element={<InfluencerProfileEdit />} />
        <Route path="/InfluencerConsignments" element={<InfluencerConsignments />} />
        <Route path="/InfluencerHistory" element={<InfluencerHistory />} />
        <Route path="/InfluencerPendingRequest" element={<InfluencerPendingRequest />} />
        <Route path="/compare" element={<InfluencerCompare />} />
        <Route path="/consolidation" element={<Influencerconsolidation />} />
        <Route path="/ManagerHome" element={<ManagerHome />} />
        <Route path="/ManagerLogin" element={<ManagerLogin />} />
        <Route path="/ManagerHeader" element={<ManagerHeader />} />
        <Route path="/AddNewInfluencer" element={<AddNewInfluencer />} />
        <Route path="/AddNewBrand" element={<AddNewBrand />} />
        <Route path="/ManagerProfile" element={<ManagerProfile />} />
        <Route path="/complaint" element={<RaiseComplaint/>} />
            <Route path="/influencercomplaint" element={<RaiseComplaintInfluencers/>} />
              <Route path="/allinfluencercomplaint" element={<InfluencersComplaint/>} />
        <Route path="/brandcomplaint" element={< BrandComplaint/>} />
          <Route path="/brandsumitted" element={< SubmittedComplaint/>} />
            <Route path="/influencersumitted" element={< InfluencerSubmittedComplaints/>} />
        {/* Add the route for the CreateCampaign component */}
        <Route path="/create" element={<CreateCampaign />} />
          <Route path="/createlink" element={<CreateLink/>} />
            <Route path="/selectproduct" element={<InstagramProductSelect/>} />
        <Route path="/userpost" element={<Productspost/>} />
                <Route path="/myproductpost" element={< MyProducts/>} />

                <Route path="/shop" element={< Shop/>} />
                   <Route path="/partnerbrands" element={< PartnerBrands/>} />
     <Route path="/amazonproducts" element={< AmazonProductSearch/>} />
         <Route path="/commingsoon" element={< ComingSoon/>} />
          <Route path="/walmart" element={< WalmartSearch/>} />
                  <Route path="/affiliateanalytics" element={< AffiliateAnalytics/>} />
                <Route path="/generatelink" element={< GenerateProductLink/>} />
                  <Route path="/affilatecsv" element={< AffiliateCsvUpload/>} />
                       <Route path="/Manageraffilatesrequest" element={< AffiliateRequests/>} />
                         <Route path="/influencerearnings" element={< InfluencerAffiliateEarnings/>} />
             
       
      </Routes>
    </BrowserRouter>
  );
};

export default App;
